/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';

import Enzymes from 'molbio/enzymes/backbone/Enzymes';

class EnzymeList extends Backbone.Model {
  url() {
    const base = '/1/api/enzyme-lists/';
    if (this.get('id') != null) {
      return base + this.get('id');
    } else {
      return base;
    }
  }

  defaults() {
    return {
      name: '',
      description: '',
      members: [],
    };
  }

  parse(response) {
    if (this.enzymes == null) {
      this.enzymes = Enzymes.getCommonEnzymes();
    }
    const {members} = response;
    response.members = Array.from(members).map((member) => this.enzymes.get(member));
    return response;
  }
}

export default EnzymeList;
